import React from "react";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/sections/Navbar";
import Hero from "@/sections/Hero";
import WhyChooseUs from "@/sections/WhyChooseUs";
import Destinations from "@/sections/Destinations";
import Packages from "@/sections/Packages";
import Services from "@/sections/Services";
import About from "@/sections/About";
import Stats from "@/sections/Stats";
import Testimonials from "@/sections/Testimonials";
import Gallery from "@/sections/Gallery";
import FAQ from "@/sections/FAQ";
import CTA from "@/sections/CTA";
import Contact from "@/sections/Contact";
import Footer from "@/sections/Footer";
import FloatingButtons from "@/components/FloatingButtons";
import Loader from "@/components/Loader";

export default function App() {
  return (
    <div className="App bg-white text-[#222] font-[Poppins]">
      <Loader />
      <Navbar />
      <main>
        <Hero />
        <WhyChooseUs />
        <Destinations />
        <Packages />
        <Services />
        <About />
        <Stats />
        <Testimonials />
        <Gallery />
        <FAQ />
        <CTA />
        <Contact />
      </main>
      <Footer />
      <FloatingButtons />
      <Toaster position="bottom-left" richColors />
    </div>
  );
}
